module.exports = __webpack_public_path__ + "img/Glass-Chopping-Boards.90328a23.jpg";